import PersonalEmployeeLeaveEntitlementList from "@/modules/personal/stores/leave/entitlement/personal_employee_leave_entitlement_list";
import PersonalEmployeeLeaveManageApplication from "@/modules/personal/stores/leave/application/personal_leave_manage_application";

export default {
  modules: {
    PersonalEmployeeLeaveEntitlementList,
    PersonalEmployeeLeaveManageApplication,
  },
};
